import { BusinessDetails } from '@App/common/models';
import { environment } from '@Environments';

export const CARD_SOCIAL_IMAGE_WIDTH = 889;
export const CARD_SOCIAL_IMAGE_HEIGHT = 500;
export const CARD_SOCIAL_IMAGE_TYPE = 'image/jpeg';

export interface CardSocialImage {
  url: string;
  width: number;
  height: number;
  type: string;
}

const FALLBACK_IMAGE: CardSocialImage = {
  url: 'https://pitch59-prod.s3.amazonaws.com/6e340b2004a545b3b4de908f3cc3e7ab.jpg',
  width: 500,
  height: 263,
  type: CARD_SOCIAL_IMAGE_TYPE
};

export function normalizeCardAlias(alias: string | null | undefined): string {
  const normalized = (alias || '').trim();
  return normalized === 'rent-duck' ? 'rent-duck-com' : normalized;
}

export function getCardCanonicalUrl(alias: string): string {
  const baseUrl = environment.appBaseUrl.replace(/\/+$/, '');
  return `${baseUrl}/card/${encodeURIComponent(alias)}`;
}

export function getCardSocialTitle(card: BusinessDetails): string {
  if (card.businessType === 'job') {
    return card.businessName?.trim() || card.name?.trim() || 'Pitch59';
  }

  if (
    (card.businessType === 'service' || card.businessType === 'employee') &&
    card.businessName &&
    !card.isHideTitle
  ) {
    const name = card.name?.trim() || card.businessName.trim();
    return name === card.businessName.trim()
      ? name
      : `${name} (${card.businessName.trim()})`;
  }

  return card.name?.trim() || card.businessName?.trim() || 'Pitch59';
}

export function getCardSocialDescription(card: BusinessDetails): string {
  const categories = Array.isArray(card.categories)
    ? card.categories.filter(Boolean).slice(0, 3).join(', ')
    : '';
  const description =
    card.title?.trim() ||
    card.writtenElevatorPitchScript?.trim() ||
    categories ||
    `View ${getCardSocialTitle(card)} on Pitch59.`;

  return description.length > 200
    ? `${description.slice(0, 197).trimEnd()}...`
    : description;
}

export function getCardSocialImage(card: BusinessDetails): CardSocialImage {
  const sourceUrl = card.videoCoverImageThumbnailUrl?.trim();
  const fileId = card.videoCoverImageFileId?.trim();

  let response = sourceUrl.split('/');
  response[response.length - 1] = `IP_${card.id}.jpg?v=3`
  let imageUrl = response.join('/');
  if (sourceUrl && fileId && sourceUrl.includes(fileId)) {
    return {
      url: imageUrl,
      width: CARD_SOCIAL_IMAGE_WIDTH,
      height: CARD_SOCIAL_IMAGE_HEIGHT,
      type: CARD_SOCIAL_IMAGE_TYPE
    };
  }

  return FALLBACK_IMAGE;
}
